import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const PlasmaWaveAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  ctx.beginPath();
  for(let a=0; a<Math.PI*2; a+=0.1){
    const baseR = e.maxRadius + progress * 100 * (1 + 0.3 * Math.sin(a*10 + progress*20));
    const r = getRadiusAtAngle(a, e, baseR);
    ctx.lineTo(e.pos.x + Math.cos(a)*r, e.pos.y + Math.sin(a)*r);
  }
  ctx.closePath(); ctx.stroke();
};

registerBlastAnimation('PLASMA_WAVE', PlasmaWaveAnimation);
